export default __webpack_public_path__ + "static/media/taxBG.fdda8383.svg";